export default "__VITE_ASSET__af1099b5__"